import { useFeatureFlags } from 'contexts/FeatureFlagsContext';
import React, { PropsWithChildren } from 'react';
import { FeatureFlagId } from 'types/featureflags';

interface IFeatureFlagCheckProps extends PropsWithChildren {
	flag: FeatureFlagId;
}

const FeatureFlagCheck: React.FC<IFeatureFlagCheckProps> = ({
	flag,
	children = null
}) => {
	const { isFeatureFlagActive } = useFeatureFlags();

	return isFeatureFlagActive(flag) ? children : null;
};

export default FeatureFlagCheck;
